// MzdyTab — tab "Mzdy" v detaile zákazky. Ústava 22.1: READ-ONLY, iba štatistika. Zápis cez Zamestnanci → Mzdy.
// Port z MOCKUP_Zakazka_Detail_FULL.html (#t7): Partia/osoba · VV línia · Obdobie · Suma €.
import React, { useEffect, useState, useMemo } from 'react'

const H = () => ({ Authorization: `Bearer ${localStorage.getItem('kamir_token') || ''}` })
const f2 = (n) => (Number(n) || 0).toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const C = { brand: '#15171A', violet: '#5b21b6', green: '#41694C', red: '#8C2F12', line: '#E4E1DA', muted: '#6E7177', ink: '#15171A' }
const stripObj = (d) => (d || '').replace(/^\[[^\]]+\]\s*/, '')
const ST = {
  'zaplatená': { bg: '#ecfdf3', co: C.green }, 'zaplatena': { bg: '#ecfdf3', co: C.green },
  'schválená': { bg: '#eff6ff', co: '#1B4A5A' }, 'schvalena': { bg: '#eff6ff', co: '#1B4A5A' },
  'na schválenie': { bg: '#fff7ed', co: '#b45309' }, 'na schvalenie': { bg: '#fff7ed', co: '#b45309' },
  'návrh': { bg: '#f3f4f6', co: '#6b7280' },
}

export default function MzdyTab({ projectId }) {
  // zakazky_v1 (15. 10. 2026): táto záložka čítala starú tabuľku payroll, kým karta Info
  // počíta zo zošita Mzdy 2026 — na tej istej zákazke svietili dve rôzne čísla.
  // Teraz obe čítajú to isté. A zamietnutie prístupu sa už netvári ako „žiadne mzdy".
  const [rows, setRows] = useState(null)
  const [sucty, setSucty] = useState(null)
  const [chyba, setChyba] = useState(null)
  useEffect(() => {
    setRows(null); setChyba(null)
    fetch(`/api/projects/${encodeURIComponent(projectId)}/mzdy-riadky`, { headers: H() })
      .then(async r => {
        if (r.status === 401 || r.status === 403) { setChyba('prava'); setRows([]); return null }
        if (!r.ok) { setChyba('server'); setRows([]); return null }
        return r.json()
      })
      .then(d => { if (!d) return; setRows(Array.isArray(d.riadky) ? d.riadky : []); setSucty(d) })
      .catch(() => { setChyba('server'); setRows([]) })
  }, [projectId])

  const total = useMemo(() => (sucty ? sucty.spolu : (rows || []).reduce((s, r) => s + (+r.suma || 0), 0)), [rows, sucty])
  const supisTotal = useMemo(() => (sucty ? sucty.do_supisu : 0), [sucty])
  if (rows === null) return <div style={{ padding: 20, color: C.muted }}>Načítavam mzdy…</div>
  if (chyba === 'prava') return (
    <div style={{ padding: 24, color: C.muted, border: `1px dashed ${C.line}`, borderRadius: 9, textAlign: 'center' }}>
      <b style={{ color: C.ink }}>Mzdy na zákazke vidí vedenie a office.</b><br />
      <span style={{ fontSize: 12 }}>Nie je to tak, že by tu mzdy neboli — nemáš na ne právo.</span>
    </div>
  )
  if (chyba === 'server') return (
    <div style={{ padding: 24, color: C.red, border: `1px dashed ${C.line}`, borderRadius: 9, textAlign: 'center' }}>
      Mzdy sa nepodarilo načítať. Skús to znova.
    </div>
  )

  const th = { background: '#f3eee7', color: C.muted, fontSize: 10, textTransform: 'uppercase', fontWeight: 700, padding: '8px 9px', textAlign: 'right', borderBottom: `1px solid ${C.line}`, whiteSpace: 'nowrap' }
  const td = { padding: '7px 9px', borderBottom: '1px solid #f1ede7', textAlign: 'right', fontFamily: 'ui-monospace,Menlo,monospace', fontSize: 12.5 }
  const zdrojSt = { zosit: { bg: '#eff6ff', co: '#1B4A5A', t: 'zošit' }, archiv: { bg: '#f3f4f6', co: '#6b7280', t: 'archív' } }

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
        <h3 style={{ margin: 0, flex: 1, fontSize: 15 }}>Mzdy na zákazke ({rows.length})</h3>
        <span style={{ fontSize: 11, fontWeight: 700, color: '#fff', background: C.muted, padding: '3px 10px', borderRadius: 6 }}>READ-ONLY · iba štatistika</span>
      </div>

      <div style={{ display: 'flex', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
        <Kpi label="Σ Mzdy (náklad)" val={f2(total) + ' €'} color={C.red} bg="#fdecec" />
        <Kpi label="Σ Zahrnuté do súpisu" val={f2(supisTotal) + ' €'} color={C.green} bg="#ecfdf3" />
        <Kpi label="Počet záznamov" val={String(rows.length)} color={C.ink} />
      </div>

      {!rows.length ? (
        <div style={{ padding: 24, color: C.muted, border: `1px dashed ${C.line}`, borderRadius: 9, textAlign: 'center' }}>Žiadne mzdy priradené na túto zákazku.<br /><span style={{ fontSize: 12 }}>Mzdy sa zapisujú v <b>Mzdy 2026</b> (kniha partie) a zo Súpisu › Podklady.</span>{/* MZDY_KARTA_ZOSIT_V1 */}</div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5 }}>
          <thead><tr>
            <th style={{ ...th, textAlign: 'left' }}>Partia / osoba</th><th style={{ ...th, textAlign: 'left' }}>Popis</th>
            <th style={{ ...th, textAlign: 'center', width: 90 }}>Obdobie</th><th style={{ ...th, textAlign: 'center', width: 90 }}>Zdroj</th>
            <th style={{ ...th, width: 60 }}>súpis</th><th style={{ ...th, width: 100 }}>Suma €</th>
          </tr></thead>
          <tbody>
            {rows.map(r => {
              const zs = zdrojSt[r.zdroj] || zdrojSt.archiv
              const [rok, mes] = String(r.obdobie || '').split('-')
              return (
                <tr key={r.id}>
                  <td style={{ ...td, textAlign: 'left', fontFamily: 'inherit', fontWeight: 600 }}>{r.osoba || '—'}</td>
                  <td style={{ ...td, textAlign: 'left', fontFamily: 'inherit', fontSize: 11.5, color: C.muted }}>{r.popis ? stripObj(r.popis) : <span style={{ color: '#c4bcb0' }}>—</span>}</td>
                  <td style={{ ...td, textAlign: 'center' }}>{mes ? mes + '/' + rok : (r.obdobie || '—')}</td>
                  <td style={{ ...td, textAlign: 'center', fontFamily: 'inherit' }}><span style={{ fontSize: 11, fontWeight: 700, padding: '2px 9px', borderRadius: 6, background: zs.bg, color: zs.co }}>{zs.t}</span></td>
                  <td style={{ ...td, textAlign: 'center' }}>{r.do_supisu ? <span title="Zahrnuté do súpisu">✓</span> : <span style={{ color: '#c4bcb0' }}>—</span>}</td>
                  <td style={{ ...td, color: C.red, fontWeight: 700 }}>{f2(r.suma)}</td>
                </tr>
              )
            })}
            <tr><td colSpan={5} style={{ ...td, textAlign: 'left', background: '#f3eee7', fontWeight: 800, borderTop: `2px solid ${C.line}` }}>Spolu mzdy (náklad zákazky)</td><td style={{ ...td, background: '#f3eee7', color: C.red, fontWeight: 800, fontSize: 14, borderTop: `2px solid ${C.line}` }}>{f2(total)}</td></tr>
          </tbody>
        </table>
      )}
      {sucty && sucty.spolu_archiv > 0 && (
        <div style={{ fontSize: 11.5, color: C.muted, marginTop: 10 }}>
          Z toho zo zošita Mzdy 2026: <b>{f2(sucty.spolu_zosit)} €</b> · z archívu do 30. 6. 2026: <b>{f2(sucty.spolu_archiv)} €</b>.
          Archívny mesiac, ktorý už pokrýva zošit, sa neráta druhýkrát.
        </div>
      )}
      <div style={{ fontSize: 11.5, color: C.muted, marginTop: 10 }}><b>Mzdy sa zapisujú v Mzdy 2026 (kniha partie)</b> — tu je len prehľad pre štatistiku (čerpanie / ziskovosť / prečerpanie). Žiadny zápis tu (ústava 22.1). ✓ = zahrnuté do súpisu prác → fakturácia zákazníkovi.</div>
    </div>
  )
}
function Kpi({ label, val, color, bg }) {
  return <div style={{ border: `1px solid ${C.line}`, borderRadius: 9, padding: '9px 13px', background: bg || '#fff', minWidth: 140, flex: '1 1 140px' }}>
    <div style={{ fontSize: 10, textTransform: 'uppercase', color: C.muted, fontWeight: 700 }}>{label}</div>
    <div style={{ fontSize: 17, fontWeight: 800, fontFamily: 'ui-monospace,Menlo,monospace', marginTop: 3, color }}>{val}</div>
  </div>
}
